export const useScrollStore = defineStore('scrollStore', {
	state: () => ({
		isScrollEnabled: false,
		downPosition: "top top",
		upPosition: "bottom bottom",
		isViewportFits: true
	}),
	getters: {
		getScrollEnabled: (state) => {
			return state.isScrollEnabled;
		},
		getViewportFits: (state) => {
			return state.isViewportFits
		},
		scrollUpPosition: (state) => {
			return state.downPosition;
		},
		scrollDownPosition: (state) => {
			return state.upPosition;
		},
	},
	actions: {
		setViewportNormal(value) {
			if (!value) {
				this.isScrollEnabled = false
			}

			this.isViewportFits = value;
		},
	}
})
